import { updateArrowClasses, updateArrows, updateDots, updateNavFor } from './updates';
import { applyTransition, unapplyTransition, reduceTransition } from './animations';
import { getCurrentSlide } from './util';
import { emit } from './event-hooks';

export function changeSlide(change, isIncremental, forceUpdate = false){
	let currentSlide = this.currentSlide;
	let previousSlide = this.currentSlide;

	if(isIncremental){
		currentSlide += change * (this.config.options.slidesToScroll || 1);
	}else{
		currentSlide = change;
	}

	currentSlide = Math.min(Math.max(currentSlide, this.minSlidePos), this.maxSlidePos);

	if(this.currentSlide != currentSlide || forceUpdate){
		this.currentSlide = currentSlide;
		this.previousSlide = previousSlide;

		if(this.config.options.fade){
			if(this.currentSlide ==  this.maxSlidePos){
				this.currentSlide = 0;
			}

			if(this.currentSlide == this.minSlidePos){
				this.currentSlide = this.maxSlidePos - 1;
			}
		}

		updateNavFor.call(this);
		updateArrowClasses.call(this);
		updateArrows.call(this);
		updateDots.call(this);
		slideHandler.call(this);

		emit.call(this, this.events.slideChange, getCurrentSlide.call(this));
	}
}

export function slideHandler(){
	let transform = 100 * (this.currentSlide + this.slideOffset) / this.config.options.slidesToShow;
	this.elements.track.style.transform = `translateX(-${transform}%)`;

	if(this.config.options.fade){
		fadeSlider.call(this);
	}
}

export function swipeHandle(change){
	if(!change){
		return;
	}

	if(typeof change == 'string'){
		if(change == 'down' && !this.swipeIsDown){
			this.currentSwipePosition = 0;
			this.swipeIsDown = true;
			unapplyTransition.call(this);
		}else if(change == 'up' && this.swipeIsDown){
			this.swipeIsDown = false;
			this.swipePosition += this.currentSwipePosition;
			this.swipeDirection = this.currentSwipePosition > 0 ? -1 : 1;
			applyTransition.call(this);
		}else if(change == 'end' && !this.swipeIsDown){
			const transform = this.slideWidth * (this.currentSlide) - this.swipePosition;
			const tendTowardsSwipeDirectionSlide = this.swipeDirection * this.config.options.swipeThreshold;
			let currentSlidePercentage = transform / this.slideWidth;
			let currentSlide = Math.round(currentSlidePercentage + tendTowardsSwipeDirectionSlide);

			currentSlide = Math.min(Math.max(currentSlide, this.minSlidePos), this.maxSlidePos);

			const speedPercentage = currentSlidePercentage - Math.floor(currentSlidePercentage);
			applyTransition.call(this, speedPercentage);

			changeSlide.call(this, currentSlide, false, true);
			this.swipePosition = 0;
		}
	}

	if(typeof change == 'object' && this.swipeIsDown){
		this.currentSwipePosition = change.left;
		let transform = this.slideWidth * (this.currentSlide + this.slideOffset) - this.currentSwipePosition - this.swipePosition;
		if(transform <= 0){
			this.currentSwipePosition += transform;
		}else if(transform >= this.maxSwipePosition){
			this.currentSwipePosition -= this.maxSwipePosition - transform;
		}
		transform = Math.min(Math.max(transform, 0), this.maxSwipePosition);
		this.elements.track.style.transform = `translateX(-${transform}px)`;
	}

}

export function updateInfiniteSlides(){
	if(this.config.options.infinite && this.currentSlide != this.minSlidePos && this.currentSlide != this.maxSlidePos){
		return;
	}

	if(this.currentSlide == this.minSlidePos){
		reduceTransition.call(this);
		this.currentSlide = this.slideCount - this.config.options.slidesToShow;
		slideHandler.call(this);
	}

	if(this.currentSlide == this.maxSlidePos){
		reduceTransition.call(this);
		this.currentSlide = 0;
		slideHandler.call(this);
	}
}

function fadeSlider(){
	const positionDiffrence = this.currentSlide - this.previousSlide;
	let slideTransform = 100 * positionDiffrence;

	const prevSlideEl = this.elements.slides[this.previousSlide];
	const curSlideEl = this.elements.slides[this.currentSlide];

	prevSlideEl.style.transition = `opacity ${this.config.options.speed || 500}ms ${this.config.options.ease || 'linear'}`;
	prevSlideEl.style.transform = `translate(${slideTransform}%)`;
	prevSlideEl.style.opacity = 0;
	prevSlideEl.style['z-index'] = 2;

	curSlideEl.style.transition = '';
	curSlideEl.style.transform = '';
	curSlideEl.style.opacity = 1;
	curSlideEl.style['z-index'] = 1;
}

export function cleanupFade(){
	const currentSlide = this.currentSlide % (this.maxSlidePos - 1);
	const prevSlideEl = this.elements.slides[this.previousSlide];
	const curSlideEl = this.elements.slides[currentSlide];

	prevSlideEl.style.transition = '';
	prevSlideEl.style.transform = '';
	prevSlideEl.style.opacity = '';
	prevSlideEl.style['z-index'] = 0;

	curSlideEl.style.opacity = '';
	curSlideEl.style['z-index'] = 1;
}



// WEBPACK FOOTER //
// ./node_modules/ui-slider/app/js/src/slider/slide-handlers.js